module.exports = __webpack_public_path__ + "static/media/Telus_One_page-16.d5c543d1.png";